import React, { useState, useEffect } from 'react';
import FancyInput from '../elements/FancyInput';
import FancySelect from '../elements/FancySelect/FancySelect';
import Errors from '../elements/Errors';

const POSTCODE_REGEX = /^(0[289][0-9]{2})|([1-9][0-9]{3})$/;

const SqAddressList = (props) => {
    const [showManualInput, setShowManualInput] = useState(false);
    const [formData, setFormData] = useState({
        unitNumber: "",
        streetNumber: "",
        streetName: "",
        streetType: "",
        suburb: "",
        postcode: "",
        state: ""
    });
    const [formError, setFormError] = useState({
        streetNumberError: "",
        streetNameError: "",
        streetTypeError: "",
        suburbError: "",
        postcodeError: "",
        stateError: ""
    });
    const [response, setResponse] = useState();

    const stateList = ['NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'ACT', 'NT'];
    
    const streetTypeList = [
        "St",
        "Rd",
        "Pl",
        "Dr",
        "Ct",
        "Ave",
        "Bvd",
        "Gr",
        "Hwy",
        "Ally",
        "Arc",
        "Bypa",
        "Cct",
        "Cl",
        "Crn",
        "Cres",
        "Cds",
        "Esp",
        "Grn",
        "Jnc",
        "Lane",
        "Link",
        "Mews",
        "Pde",
        "Rdge",    
        "Sq",
        "Tce"
    ]

    useEffect(() => {
        setShowManualInput(false);
    }, [props.addressList]);

    useEffect(() => {
        setResponse(props.response);
    }, [props.response]);
    
    const handleShowManualInput = (e) => {
        e.preventDefault();
        setShowManualInput(true);
    }
    
    const handleCloseManualSearch = (e) => {
        e.preventDefault();
        setShowManualInput(false);
    }

    const handleCloseNoAddressFound = () => {
        setShowManualInput(false);
        props.handleResetManualSearch();
        setResponse({});
    }
    
    const handleChange = (e) => { 
        setFormError({
            ...formError,
            [e.target.name + 'Error']: ""
        })
        let box = document.getElementsByClassName(`input-${e.target.name}`)[0];
        if (box !== undefined) {
            box.style.borderColor = '#e0e0e0';
        }
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
        if (e.target.name === "postcode") {
            const valid = POSTCODE_REGEX.test(e.target.value);
            if (!valid) {
                setFormError({
                    ...formError,
                    postcodeError: "Please enter correct postcode!"
                })
            }
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const { unitNumber, streetNumber, streetName, streetType, suburb, postcode, state } = formData;        
        const unit = unitNumber !== "" ? 'Unit ' + unitNumber : "";                

        let formDataCheck = {
            ...formData
        };
        delete formDataCheck.unitNumber;
            
        let tempFormError = {
            streetNumberError: "",
            streetNameError: "",
            streetTypeError: "",
            suburbError: "",
            postcodeError: "",
            stateError: ""
        };
        
        if (Object.values(formDataCheck).some(value => value === "")) {            
            Object.keys(formDataCheck).map((item, index) => { 
                if (formDataCheck[item] === "") {
                    let box = document.getElementsByClassName(`input-${item}`)[0];
                    if (box !== undefined) {
                        box.style.borderColor = 'red';
                    }
                    tempFormError = {
                        ...tempFormError,
                        [item + "Error"]: `The ${transformName(item)} field is required.`
                    }                             
                }
            })
            setFormError(...formError, tempFormError);
        }        
        
        if ((!Object.values(formDataCheck).some(value => value === "")) && (Object.values(formError).some(value => value === ""))) {  
            let address = unit + " " + streetNumber + " " + streetName + " " + streetType + ", " + suburb + " " + state + " " + postcode;
            props.handleSearchAddress(address, e);            
            props.handleSetManualSearch();
        }  
    }

    const transformName = (item) => {
        if (item === "streetNumber") {
            return 'street number';
        } else if (item === 'streetName') {
            return 'street name';
        } else if (item === 'streetType') {
            return 'street type';
        } else if (item === 'state') {
            return 'state';
        } else {
            return item;
        }
    };

    const handleSelectStreetTypeChange = (value) => {
        setFormError({
            ...formError,
            streetTypeError: ""
        })
        setFormData({
            ...formData,
            streetType: value
        })
    };

    const handleSelectStateChange = (value) => {
        setFormError({
            ...formError,
            stateError: ""
        })
        setFormData({
            ...formData,
            state: value
        })
    };

    const Close = <div className="close-no-address" onClick={props.handleBlur}><img src="/images/close-darkgreen.svg" /></div>;
    const CloseManual = <div className="close-no-address" onClick={handleCloseNoAddressFound}><img src="/images/icon-close.svg" /></div>;

    if (props.hasManualSearched && !showManualInput && response.status === 'error') {
        return (
            <div className="address-list call-for-help-message manual-input">
                <p className="semi-bold color-indigo font-smaller pr-lg-5">
                    Unfortunately we can't find any available services for your address. Please give us a call on <a className="color-lime d-inline" href='tel: 133938'>13 39 38</a> as in some cases we can be of more assistance over the phone.
                </p>
                {CloseManual}
            </div>
        )
    }

    if (!showManualInput) {
        if (props.addressList.length > 0) {
            return (
                <div className="address-list">
                    {props.addressList.length > 0 ? (props.addressList[0].label === "No address found." && Close) : ''}
                    {props.addressList.length > 0 && props.addressList.slice(0,6).map((item, index) => {
                        return (
                            <a key={index} href="#" onClick={event => props.handleAddressClick(item, event)}>{item.address}</a>
                        )
                    })}
                    <a href="#" onClick={handleShowManualInput}>Can't find your address? Enter it manually</a>
                </div>
            )
        } else {
            return null;
        }
    } else {
        return (
            <div className="manual-input address-list">
                <div className="d-flex manual-container">
                    <p className="semi-bold color-indigo font-large">Manually enter your address below:</p>
                    <a href="#" className="d-flex close-btn color-indigo" onClick={handleCloseManualSearch}>
                        <img src="/images/close-darkgreen.svg" alt="close search" />
                        <span className="font-small">Close search</span>
                    </a>
                </div>
                <form className="manual-form">
                    <div className="form-row row">
                        <div className="col-md-6 p-0">
                            <FancyInput name="unitNumber" label="Unit Number: (Optional)" value={formData.unitNumber} handleChange={e => handleChange(e)} />
                        </div>
                        <div className="col-md-6 p-0">
                            <FancyInput name="streetNumber" label="Street Number:" value={formData.streetNumber} handleChange={e => handleChange(e)} />
                        </div>
                        <div className="col-md-6 p-0 mt-lg-3 mt-0">
                            <FancyInput name="streetName" label="Street Name:" value={formData.streetName} handleChange={e => handleChange(e)} />
                        </div>
                        <div className="col-md-6 p-0 mt-lg-3 mt-5">
                            <FancySelect
                                title="Street Type:"
                                theme="indigo"
                                list={streetTypeList}
                                setValue={(value) => handleSelectStreetTypeChange(value)}
                            />
                        </div>
                        <div className="col-md-6 p-0 mt-lg-3 mt-0">
                            <FancyInput name="suburb" label="Suburb:" value={formData.suburb} handleChange={e => handleChange(e)} />
                        </div>
                        <div className="col-md-3 p-0 mt-3">
                            <FancyInput name="postcode" label="Postcode:" value={formData.postcode} handleChange={e => handleChange(e)} />
                        </div>
                        <div className="col-md-3 p-0 mt-lg-3 mt-5">                         
                            <FancySelect
                                title="State:"
                                theme="indigo"
                                list={stateList}
                                setValue={(value) => handleSelectStateChange(value)}
                            />
                        </div>
                        {Object.values(formError).some(value => value !== "") && <Errors errors={Object.values(formError)} className="error-message-container mt-3" />}    
                        <button type="submit" className="mb-3 mt-5 font-large submit-button" onClick={handleSubmit}>Manual Search</button>
                        
                    </div>
                </form>
            </div>
        )
    }
}

export default SqAddressList;


// WEBPACK FOOTER //
// ./resources/assets/js/nbn/SqAddressList.js